import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { TRAFFIC_FINE_SERVICE } from '../EndPoints';

/**
 * @Author      Jhovanny Fragoso Márquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */


export const CreateFineType = createAsyncThunk("fineType/createFineType", async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(TRAFFIC_FINE_SERVICE.createFineType, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateFineType = createAsyncThunk("fineType/updateFineType", async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(TRAFFIC_FINE_SERVICE.updateFineType, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
